import {z} from 'zod';

export const DashboardFormSchema = z.object({
  salesFunnelBusinessCases: z.boolean(),
  salesFunnelInterests: z.boolean(),
  hasSalesFunnel: z.boolean(),
  vehicleStock: z.boolean(),
  latestVehicles: z.boolean(),
  latestBusinessCases: z.boolean(),
  latestInterests: z.boolean(),
  notifications: z.boolean(),
  myTasks: z.boolean(),
  workshopOverview: z.boolean(),
  workshopCritical: z.boolean(),
  workshopWarning: z.boolean(),
  workshopToday: z.boolean(),
  workshopVehiclesNotArrived: z.boolean(),
  workshopOverpricedOrders: z.boolean(),
  workshopOverdueOrders: z.boolean(),
  workshopOrdersBelowMinimumMargin: z.boolean(),
  workshopUnclosedWarrantyClaims: z.boolean(),
  workshopOrdersWithoutDateOrPrice: z.boolean(),
  workshopRepeatedRepairs: z.boolean(),
  workshopToCompleteToday: z.boolean(),
  workshopTodaysVehicleArrivals: z.boolean(),
});

export type DashboardFormSchemaType = z.infer<typeof DashboardFormSchema>;
